const basePath = window.__ENV.REACT_APP_BASE_PATH || '/application';

export default config => {
  const configUpdate = config;
  if (!config.url.startsWith('http') && !config.url.startsWith(basePath)) {
    configUpdate.url = `${basePath}${config.url}`;
  }
  return configUpdate;
};
